import { render, staticRenderFns } from "./itemImageGrid.vue?vue&type=template&id=3743d8ec"
import script from "./itemImageGrid.vue?vue&type=script&lang=ts"
export * from "./itemImageGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLargeArrowLeft: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconLargeArrowLeft.vue').default,IconLargeArrowRight: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconLargeArrowRight.vue').default,ElementSnapSlider: require('/codebuild/output/src3458403893/src/acredo-website/components/element/elementSnapSlider.vue').default})
